export default __webpack_public_path__ + "static/media/logo.e282ed9f.png";